import { render, staticRenderFns } from "./StandaloneDownloadCard.vue?vue&type=template&id=a545548a"
import script from "./StandaloneDownloadCard.vue?vue&type=script&lang=ts"
export * from "./StandaloneDownloadCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports